export const colorReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_TEXT_COLOR':
            return {
                ...state,
                textColor: action.color
            }
        case 'UPDATE_BACKGROUND_COLOR':
            return {
                ...state,
                backgroundColor: action.color
            }
        case 'UPDATE_LOGO_COLOR':
            return {
                ...state,
                logoColor: action.color
            }
        default:
            return state;
    }
}
